// @flow

import type { Endpoints, EntityFieldCollection, SortParams } from '../types';
import { createdAtField, idField } from '../abstract/StoredEntity';
import type { StoredEntity } from '../abstract/StoredEntity';
import { constructEndpoints } from '../helpers';
import { DescendingSortOrder } from '../types';

class AuthSession implements StoredEntity {
    static classInternalName = 'auth_session';

    static fields: EntityFieldCollection = {
        id: idField,
        createdAt: createdAtField,
        userId: {
            displayName: 'User',
            recordName: 'user_id',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: false,
            needToCreate: undefined,
            canEdit: false,
            isOptional: false,
            displayOnMain: true,
        },
        userType: {
            displayName: 'User Type',
            recordName: 'user_type',
            dataType: {
                primitive: 'enum',
                isArray: false,
                extraData: {
                    1: 'Admin',
                    2: 'User',
                    3: 'Org User',
                },
            },
            supportsQuery: true,
            supportsSort: false,
            needToCreate: undefined,
            canEdit: false,
            isOptional: false,
            displayOnMain: true,
        },
        expiresAt: {
            displayName: 'Expiration',
            recordName: 'expires_at',
            dataType: {
                primitive: 'ts',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: undefined,
            canEdit: true,
            isOptional: false,
            displayOnMain: true,
        },
        invalidated: {
            displayName: 'Invalidated',
            recordName: 'invalidated',
            dataType: {
                primitive: 'bool',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: undefined,
            canEdit: true,
            isOptional: false,
            displayOnMain: true,
        },
    };

    static fileFields: EntityFieldCollection = {};

    static defaultSort: SortParams = {
        field: AuthSession.fields.expiresAt,
        fieldName: 'expires_at',
        order: DescendingSortOrder,
    };

    get id() {
        return this.record[AuthSession.fields.id.recordName];
    }

    get displayName() {
        return this.record[AuthSession.fields.id.recordName];
    }

    static endpoints: Endpoints = constructEndpoints('auth-sessions');

    constructor(record: any) {
        this.record = record;
    }
}

export default AuthSession;
